import APIError from '../APIError';
class InternalServerError extends APIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        const status = 500;
        super(status, ...args);
    }
}
export default InternalServerError;
